/**
 * Responder a una nota interna (punto 4): la cita que se ve arriba de la respuesta y en el compose.
 * El backend guarda su propia copia al crear la respuesta; ésta es la del compose, antes de enviar.
 */
import type { NoteReplyTo, NoteView } from "@/services/conversations.api";

export const LARGO_DE_LA_CITA = 140;

/** El comienzo de una nota para citarla: las menciones como `@Nombre`, en una línea. */
export function citaDe(content: string): string {
  const plano = content
    .replace(/@\[([^\]]*)\]\(\d+\)/g, "@$1")
    .replace(/\s+/g, " ")
    .trim();
  return plano.length > LARGO_DE_LA_CITA
    ? `${plano.slice(0, LARGO_DE_LA_CITA - 1).trimEnd()}…`
    : plano;
}

/** La cita de una nota que todavía no se respondió: la misma forma que guarda el backend. */
export function citaDeNota(note: NoteView): NoteReplyTo {
  return {
    noteId: note.noteId,
    messageId: note.messageId ?? null,
    authorUserId: note.authorUserId,
    authorName: note.authorName,
    excerpt: citaDe(note.content),
  };
}

/** A dónde lleva la cita: la burbuja si la original estaba anidada en un mensaje, si no la nota. */
export function destinoDeLaCita(r: NoteReplyTo): string {
  return r.messageId ?? r.noteId;
}
